import React from 'react';

import { serverUtils } from '../../utils/serverUtils/serverUtils';

export const hooks = {
  useCreateLink(href: string) {
    React.useEffect(() => {
      if (serverUtils.isServerSide()) {
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.media = 'print';
      link.onload = () => {
        link.media = 'all';
      };
      document.head.appendChild(link);

      return () => {
        document.head.removeChild(link);
      };
    }, [href]);
  },
};

export type Props = {
  href: string;
};

export const AsyncStylesheet = React.memo((props: Props) => {
  const {
    href,
  } = props;

  hooks.useCreateLink(href);

  return null;
});

AsyncStylesheet.displayName = 'AsyncStylesheet';
